export const errorTrackIds = {
    copyRCIDOld: {
        id: 'dagligbank-error-card-old-copy-rcid',
    },
    copyRCIDNew: {
        id: 'dagligbank-error-card-new-copy-rcid',
    },
};
